import getters from './getters';
import state from './state';
import mutation from './mutation';

const module = {
    namespaced: true,
    state: state,
    getters: getters,
    mutations: mutation,
};

export default module;



// WEBPACK FOOTER //
// ./resources/assets/js/components/vuetable2/checkbox/state/index.js